import { WebSocket as PartySocketWebSocket } from 'partysocket';

// import handleMessage from './websocketMockHandler';
class MockableWebSocket extends PartySocketWebSocket {
  send(message: string) {
    /**
     *  Check if we are handling message on client side,
     * if not forward it to server
     * */
    // if (handleMessage(message, this)) return;

    super.send(message);
  }
}

export default MockableWebSocket;
